import api from "../../../services/api/axios";

export const lookupProspectingCompanyMatches = ({ companyName, website }) =>
  api.post("/company-lookups", {
    company_name: companyName || null,
    website: website || null,
    company_type: "prospecting",
  });

export const uploadProspectingCompanyProfileDocument = (companyId, file) => {
  const form = new FormData();
  form.append("file", file, file.name);

  return api.post(`/prospecting-companies/${companyId}/profile-document`, form);
};

export const downloadProspectingCompanyProfileDocument = (
  companyId,
  documentId,
) =>
  api.get(
    `/prospecting-companies/${companyId}/profile-documents/${documentId}`,
    {
      responseType: "blob",
    },
  );

export const deleteProspectingCompanyProfileDocument = (
  companyId,
  documentId,
) => api.delete(`/prospecting-companies/${companyId}/profile-documents/${documentId}`);
